import details from './details';

export const firstCoowner = {
  ...details,
};
